var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.26 2.555 4.185 4.185c.74.74.74 1.94 0 2.68l-7.313 7.312h5.136c.32 0 .584.238.626.547l.006.085c0 .32-.238.584-.546.626l-.086.006-7.084.001a1.89 1.89 0 0 1-1.444-.552L2.555 13.26c-.74-.74-.74-1.94 0-2.68l8.024-8.025c.74-.74 1.94-.74 2.68 0ZM4.7 10.22 3.45 11.473a.632.632 0 0 0 0 .893l4.185 4.186a.63.63 0 0 0 .446.184l.025-.003.032.001a.63.63 0 0 0 .39-.183L9.78 15.3l-5.078-5.08Zm6.773-6.771L5.594 9.326l5.079 5.08 5.879-5.879a.632.632 0 0 0 0-.893l-4.186-4.185a.632.632 0 0 0-.893 0Z",
    fill: "#666"
  })));
};
export default SvgReset;